import { SIGN_PRODUCTS } from "./signsPricing";

// Searchable catalogue of every active product page.
export const CATALOG = [
  { name: "Stickers on Rolls", path: "/stickers-on-rolls", category: "Stickers", keywords: "stickers on rolls roll labels product labels high volume labelling" },
  { name: "Die-Cut Stickers", path: "/die-cut-stickers", category: "Stickers", keywords: "custom die-cut die cut stickers vinyl labels logo upload artwork circle oval square rectangle custom shape" },
  { name: "Stickers on Sheets", path: "/stickers-on-sheets", category: "Stickers", keywords: "sticker sheets stickers on sheets a4 a5 a6 kiss cut" },
  { name: "Corflute Signs", path: "/corflute", category: "Signs", keywords: "corflute signs coreflute real estate election site signage boards eyelets" },
  { name: "Foamboard Signs", path: "/foamboard", category: "Signs", keywords: "foamboard foam board signs display indoor" },
  { name: "3mm PVC Signs", path: "/pvc", category: "Signs", keywords: "pvc signs 3mm rigid shop office wayfinding" },
  { name: "Pull-Up Banners", path: "/pull-up-banners", category: "Banners", keywords: "pull-up pull up banners roll-up retractable expo trade show" },
  { name: "Feather Flags", path: "/flags", category: "Flags", keywords: "feather flags flag pole ground spike base outdoor" },
  { name: "Custom Printed Coasters", path: "/coasters", category: "Coasters", keywords: "coasters beer mats beermat drink cafe brewery wedding" },
  { name: "Media Walls", path: "/media-walls", category: "Displays", keywords: "media wall backdrop step and repeat photo wall event" },
  { name: "Aluminium A-Frame — Permanent Aluminium Signs", path: "/a-frames?type=permanent", category: "A-Frames", keywords: "a-frame aframe a frame sandwich board footpath aluminium signs permanent" },
  { name: "Aluminium A-Frame — Interchangeable Corflute Signs", path: "/a-frames?type=interchangeable", category: "A-Frames", keywords: "a-frame aframe a frame sandwich board footpath interchangeable corflute signs" },
];

export const CATALOG_IMAGES = {
  "/corflute": SIGN_PRODUCTS.corflute?.image,
  "/foamboard": SIGN_PRODUCTS.foamboard?.image,
  "/pvc": SIGN_PRODUCTS.pvc?.image,
  "/pull-up-banners": SIGN_PRODUCTS.pullup?.image,
  "/coasters": SIGN_PRODUCTS.coaster?.image,
  "/stickers-on-rolls": "/products/stickers-on-rolls-v2.webp",
  "/die-cut-stickers": "/products/custom-stickers.webp",
  "/stickers-on-sheets": "/products/stickers-on-sheets.webp",
};

const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export function searchCatalog(query) {
  const terms = norm(query).split(" ").filter(Boolean).map((t) => t.replace(/s$/, ""));
  if (!terms.length) return [];
  const match = (text) => terms.every((t) => norm(text).includes(t));
  return CATALOG.filter((p) => match(`${p.name} ${p.category} ${p.keywords}`)).slice(0, 8);
}
